import React, { Component } from 'react';
import { Col, FormGroup, Label } from 'reactstrap';


export default class UserStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStatus: 1,
            formFieldData: {
                victimStatus: [
                    { id: 1, statusEN: "Detained" },
                    { id: 2, statusEN: "Not Detained" },
                    { id: 3, statusEN: "Unknown" },
                ]
            }
        }
    }

    stateHandling = (event) => {
        this.setState({
            selectedStatus: event.target.value
        });
    }
    componentDidMount() {
    }

    render() {
        return (
            <FormGroup row>
                <Col md={9}>
                    <select
                        className="custom-select"
                        id="selectedStatus"
                        onChange={event => {
                            this.stateHandling(event);
                        }}
                        value={this.state.selectedStatus}>
                        {this.state.formFieldData.victimStatus.map((data, id) => (
                            <option key={id} value={data.id}>
                                {data.statusEN}
                            </option>
                        ))}
                    </select>
                </Col>
            </FormGroup>
        )
    }
}
